import { State } from "infrontjs";

/**
 * LogoutState — tear down the session and return to login.
 *
 * destroySession() clears the token and flips the shell back to auth; we then
 * route to /login so the URL matches.
 */
export class LogoutState extends State
{
    static ROUTE = "/logout";
    static ID = "logout";

    async enter()
    {
        await this.app.destroySession();
        this.app.router.redirect( "/login" );
    }

    async exit() {}
}
